import { Field } from "@ark-ui/react/field";
import type { ComponentProps, PropsWithChildren } from "react";
import Icon from "@mdi/react";
import { mdiInformation } from "@mdi/js";

type ErrorTextProps = Omit<ComponentProps<typeof Field.ErrorText>, "className">;
type Props = PropsWithChildren<ErrorTextProps>;

const ErrorText = ({ children, ...rest }: Props) => {
  return (
    <Field.ErrorText {...rest} className="flex gap-1 items-center text-red-500">
      <Icon path={mdiInformation} size="10px" />
      <p className="text-label3 leading-[16px]">{children}</p>
    </Field.ErrorText>
  );
};

export default ErrorText;
